import React from "react";
import { Check } from "lucide-react";

interface CheckboxProps {
  name: string;
  label: string;
  labelClassName?: string;
  isChecked: boolean;
  disabled?: boolean;
  onChange: (status: boolean) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  label,
  isChecked,
  labelClassName = "",
  disabled = false,
  onChange,
}) => {
  const isShowLabel = label.trim().length > 0;
  const stateLayerClassName = disabled
    ? "inline-flex h-10 w-10 items-center justify-center rounded-full"
    : "inline-flex h-10 w-10 items-center justify-center rounded-full cursor-pointer transition-colors duration-200 ease-out hover:bg-[#1D1B20]/[0.08] active:bg-[#1D1B20]/[0.12]";
  const checkboxContainerClassName = disabled
    ? isChecked
      ? "flex h-[18px] w-[18px] items-center justify-center rounded-[2px] border-2 border-[#A7A3AE] bg-[#A7A3AE] text-white"
      : "flex h-[18px] w-[18px] items-center justify-center rounded-[2px] border-2 border-[#A7A3AE] bg-transparent text-transparent"
    : isChecked
      ? "flex h-[18px] w-[18px] items-center justify-center rounded-[2px] border-2 border-[#00A09B] bg-[#00A09B] text-white transition-colors duration-200 ease-out"
      : "flex h-[18px] w-[18px] items-center justify-center rounded-[2px] border-2 border-[#49454F] bg-transparent text-transparent transition-colors duration-200 ease-out";
  const checkboxLabelClassName = disabled
    ? `break-all cursor-not-allowed ${labelClassName}`
    : `break-all cursor-pointer ${labelClassName}`;

  return (
    <div
      className={
        isShowLabel ? "inline-flex items-center space-x-2" : "inline-flex"
      }
    >
      <label htmlFor={name} className={stateLayerClassName}>
        <input
          type="checkbox"
          className="sr-only"
          id={name}
          name={name}
          checked={isChecked}
          disabled={disabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.checked)
          }
        />
        <span aria-hidden="true" className={checkboxContainerClassName}>
          <Check
            size={12}
            strokeWidth={3}
            className={isChecked ? "opacity-100" : "opacity-0"}
          />
        </span>
      </label>
      {isShowLabel && (
        <label htmlFor={name} className={checkboxLabelClassName}>
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
